import { List, Model, NeoModel, NotifyUtils } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import StaticOrganisationLookup from '../../Common/Models/StaticOrganisationLookup';
import { AppService, StaticDataTypes, Types } from '../StaticData/StaticDataTypes';
import StaticCurrencyLookup from '../../Common/Models/StaticCurrencyLookup';
import OrganisationMappingLookup from './Models/Lookups/OrganisationLookup';
import { TextConstants } from '../../Common/TextConstants';
import { NotificationDuration } from '../../App/Models/Enums/NotificationDuration';
import ManageOrganisationComponentVM from './components/ManageOrganisationComponentVM';
import UpdateOrganisationCommand from './Models/Commands/UpdateOrganisationCommand';

@NeoModel
export default class OrganisationVM extends Views.ViewModelBase {

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        public generalApiClient = AppService.get(Types.ApiClients.GeneralApiClient),
        private staticDataCache = AppService.get(StaticDataTypes.Services.StaticDataCache)){
        super(taskRunner);
    }

    public OrganisationList = new List(OrganisationMappingLookup);
    public CurrencyList: Model.PlainObject<StaticCurrencyLookup>[] = [];   
    public manageOrganisationComponentVM = new ManageOrganisationComponentVM();
    public showManageOrganisationComponent: boolean = false;

    public async initialise() {
        var organisationListResponse = await this.generalApiClient.getStaticOrganisationList();
        this.OrganisationList.set(organisationListResponse.data);
        this.CurrencyList = await this.staticDataCache.staticCurrencies.getDataAsync();
    }

    public async addOrganisation()
     {
       await this.manageOrganisationComponentVM.initialise();
       this.showManageOrganisationComponent = true;
    }

    public async editOrganisation(staticOrganisationLookup: StaticOrganisationLookup)
     {
       this.manageOrganisationComponentVM.manageOrganisation.mapFrom(staticOrganisationLookup).toJSObject();
       await this.manageOrganisationComponentVM.initialise();
       this.showManageOrganisationComponent = true;
    }

    public async saveOrganisation() {
        this.taskRunner.run(async () => {
            var response = await this.generalApiClient.saveStaticOrganisation((this.mapOrganisationToUpdateCommand()!.toJSObject())) 

                if (response.data.length != 0 ) {
                    NotifyUtils.addSuccess(TextConstants.Titles.Success, "The Organisation Mapping has been successfully saved.", NotificationDuration.Standard);
                }
                else {
                    NotifyUtils.add(TextConstants.Titles.Error, response.data, "danger" as any, NotificationDuration.Long);
                }
                this.manageOrganisationComponentVM.manageOrganisation = new UpdateOrganisationCommand();
                this.showManageOrganisationComponent = false;              
                this.initialise();
        });
    }

    public async displayOrganisationComponent() {
        this.showManageOrganisationComponent = true;
    }

    public async cancelOrganisation() {
        this.manageOrganisationComponentVM.manageOrganisation = new UpdateOrganisationCommand();
        this.showManageOrganisationComponent = false;
    }

    private mapOrganisationToUpdateCommand() {
        var command = new UpdateOrganisationCommand().mapFrom(this.manageOrganisationComponentVM.manageOrganisation);
        return command;
    }
}